import { render, staticRenderFns } from "./productLinkHistoryDialog.vue?vue&type=template&id=61e15ac6&scoped=true&"
import script from "./productLinkHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./productLinkHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./productLinkHistoryDialog.vue?vue&type=style&index=0&id=61e15ac6&prod&lang=scss&scoped=true&"
import style1 from "./productLinkHistoryDialog.vue?vue&type=style&index=1&id=61e15ac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e15ac6",
  null
  
)

export default component.exports